export type ProFeatureIdentifier =
  | 'rewind'
  | 'navigation'
  | 'packride'
  | 'live_tracking'
  | 'offline_map'
  | 'more'
  | 'app_start'
  | 'promo'
  | 'feed'
  | 'deeplink'
  | 'notification'
  | 'satellite_map'
  | '3d_map'
  | 'statistics'
  | 'voucher'
  | 'onboarding'
  | 'gpx_export'
  | 'gpx_export_trip'
  | 'gpx_import'
  | 'roadbook_trips'
  | 'roadbook_planned_routes'
  | 'profile'
  | 'pro_bonus_club'
  | 'route_planner'

export default function () {
  const { showUpgradeDialog } = useNativeClientService()
  const { requireLogin } = useAuthGate()

  const mainStore = useMainStore()
  const authStore = useAuthStore()

  const userNotPro = (featureIdentifier: ProFeatureIdentifier) => {
    showUpgradeDialog()

    if (mainStore.isLoadedFromApp) {
      return
    }

    let url = '/upgrade'

    if (featureIdentifier) {
      url += '?feature=' + featureIdentifier
    }

    if (import.meta.client) {
      window.open(url, '_blank')
    }
  }

  // Pro status is only knowable once we know who the user is, so authentication
  // is required first: a logged-out visitor could already be a Pro subscriber
  // and must not be pushed to the upgrade page before logging in.
  const requirePro = (
    featureIdentifier: ProFeatureIdentifier,
    proCallback?: (...args: any) => any
  ) => {
    return requireLogin(() => {
      if (!authStore.isUserPro) {
        userNotPro(featureIdentifier)
        return
      }

      proCallback?.()
    })
  }

  return {
    requirePro,
    userNotPro
  }
}
